export default function iframeSandboxDomainStrategy(metaSiteId, experiments) {
    const iframeSandboxDomainParams = {};
    if (metaSiteId) {
        const host = experiments?.iframeSandboxSecondaryHost?.enabled ? 'usrfiles' : 'filesusr';
        iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
    }
    return iframeSandboxDomainParams;
}
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map